import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto sm:px-3 md:px-20 lg:px-24 mt-10 bg-white p-4 m-4 w-full h-full" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 sm:px-3 md:px-20 lg:px-24 mt-10 bg-white p-4 m-4" }
const _hoisted_3 = { class: "col-span-2 grid grid-cols-2" }
const _hoisted_4 = { class: "m-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)
const _hoisted_6 = { class: "background: #e5e7eb26;" }
const _hoisted_7 = { class: "text-white text-lg font-bold leading-tight mb-3 pr-5" }
const _hoisted_8 = { class: "flex w-full items-center text-sm text-gray-300 font-medium" }
const _hoisted_9 = { class: "flex-1 flex items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-thumb-up" }, null, -1)
const _hoisted_11 = { class: "flex justify-end items-end" }
const _hoisted_12 = { class: "justify-end" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "spinner"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M7 6v12l10-6z"
  })
], -1)
const _hoisted_16 = {
  key: 0,
  class: "spinner"
}
const _hoisted_17 = { class: "col-span-2 mx-auto mt-16" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("small", { class: "col-span-2 flex justify-end" }, "*Join to unlock these options", -1)
const _hoisted_19 = { class: "col-span-2 mx-auto mt-16" }
const _hoisted_20 = { class: "flex-container col-span-2 flex flex-wrap justify-start" }
const _hoisted_21 = { class: "container mx-auto sm:px-3 md:px-20 lg:px-24 mt-10 p-4 m-4 w-full h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SliderCards = _resolveComponent("SliderCards")!
  const _component_PercentageLetter = _resolveComponent("PercentageLetter")!
  const _component_Disclaimer = _resolveComponent("Disclaimer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              href: "#",
              class: "block rounded-lg relative p-4 transform transition-all",
              style: _normalizeStyle({'background-image': `url(${_ctx.options.thumbnailAbsoluteUrl})`, 'background-position':'center', 'background-size': 'cover'})
            }, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.options.songTitle), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "rounded-full w-8 h-8 mr-3",
                      style: _normalizeStyle({'background-image': `url(${_ctx.options.thumbnailAbsoluteUrl})`, 'background-position':'center', 'background-size': 'cover'})
                    }, null, 4),
                    _createElementVNode("div", null, _toDisplayString(_ctx.options.bandName), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_10,
                    (_ctx.options.lastPlayed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.label_last_played) + " " + _toDisplayString(_ctx.options.lastPlayed), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.label_first_time), 1)
                        ], 64))
                  ])
                ])
              ])
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "btn navbar-toggler btn-medium flex flex-row align-middle items-center text-center p-6",
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmSelection && _ctx.confirmSelection(...args))),
                disabled: _ctx.isLoadingLyric
              }, [
                (_ctx.isLoadingLyric)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.actions_start) + " ", 1),
                      _hoisted_15
                    ], 64))
              ], 8, _hoisted_13)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["mx-auto text-center", {'preview-inactive': _ctx.kanaList.length == 0}])
          }, null, 2)
        ]),
        (_ctx.isLoadingLyric)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16))
          : _createCommentVNode("", true),
        _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.actions_select_level), 1),
        (_ctx.defaultLevels)
          ? (_openBlock(), _createBlock(_component_SliderCards, {
              key: 1,
              items: _ctx.defaultLevels,
              onSelected: _ctx.onsliderupdate
            }, null, 8, ["items", "onSelected"]))
          : _createCommentVNode("", true),
        _hoisted_18,
        (_ctx.reviewItemsList && _ctx.reviewItemsList.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.title_review_items), 1),
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewItemsList, (item) => {
                  return (_openBlock(), _createBlock(_component_PercentageLetter, {
                    key: item.item,
                    percentage: item.percentage,
                    letter: item.item
                  }, null, 8, ["percentage", "letter"]))
                }), 128))
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_Disclaimer)
    ])
  ], 64))
}